import { Command } from 'commands/Commands';

export class AddArticle extends Command {
  type: string = 'AddArticle';
  constructor(name: string, slug: string, id: string) {
    super({ name, slug }, id);
  }
  priority: number = 50;
}
